module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main-navbar'), _vm._v(" "), _c('main-content'), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17b48bdb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 40
// module chunks = 0